
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton } from '@/components';
import { FilterStatus, FilterType, Options } from '@/modules/promotion/item/model/mixins';
import { ROUTE_NAME_PROGRESS } from '@/modules/progress/router';
import { usePromotionItemList } from '@/modules/promotion/item/model/list';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PROGRESS.PROMOTION.INDEX,
    components: { AppTable, AppButton, AppCard },
    setup() {
        const { list, total, query, fetchList, actions, personaOptions } = usePromotionItemList({
            type: FilterType.Status.value,
            status: FilterStatus.AccessUnlimited.value
        });

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'Id', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                {
                    type: TableColumnType.RouterLink,
                    label: 'Used Prototype',
                    key: 'prototypeName',
                    to: row => row.prototypeLink
                },
                { type: TableColumnType.Option, label: 'Display', key: 'displayType', options: Options.DisplayType },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: Options.Status },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_PROGRESS.PROMOTION.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_PROGRESS.PROMOTION.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_PROGRESS.PROMOTION.TRANSLATE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-copy',
                        theme: 'info',
                        tooltip: 'Clone',
                        to: { name: ROUTE_NAME_PROGRESS.PROMOTION.CLONE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return {
            table,
            list,
            total,
            query,
            fetchList,
            actions,
            personaOptions,
            Options,
            FilterType,
            ROUTE_NAME_PROGRESS
        };
    }
});
